import { useState } from 'react';
import Select, { components } from 'react-select';
import { ReactComponent as DropdownIcon } from '../../../assets/pipeline/dropdown-small.svg';
import { STAGE_OPTIONS } from '../options';
import { reilmAPI } from '../../../services/apiClient';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <DropdownIcon />
  </components.DropdownIndicator>
);

const formatOptionLabel = ({ label, stageLabel }, { context }) => {
  if (context === 'value') {
    return (
      <div className="flex flex-col justify-center leading-none gap-y-[3px]">
        <span className="text-[11px] font-bold text-brand-dark uppercase tracking-wide">
          {stageLabel}
        </span>
        <span className="text-[13px] font-light text-brand-dark">
          {label}
        </span>
      </div>
    );
  }
  return <span className="text-[13px] text-brand-dark">{label}</span>;
};

const StageCellEditor = ({ params, activeStage, onStageUpdate }) => {
  const [saving, setSaving] = useState(false);

  const groupedOptions = (activeStage === 'all' ? STAGE_OPTIONS : STAGE_OPTIONS.filter(g => g.key === activeStage))
    .map(g => ({ ...g, options: g.options.map(o => ({ ...o, stageLabel: g.label })) }))
  const allOptions = groupedOptions.flatMap(g => g.options);
  const currentOption = allOptions.find(o => o.value === params.row.status) ?? null;

  const handleChange = async (selected) => {
    if (!selected || selected.value === params.row.status) return;
    setSaving(true);
    try {
      await reilmAPI.updatedPropertiesDetails(params.row.id, { stage: selected.value });
      onStageUpdate(params.row.id, selected.value);
    } catch {
      // silent — row stays unchanged on error
    } finally {
      setSaving(false);
    }
  };

  return (
    <Select
      value={currentOption}
      options={groupedOptions}
      onChange={handleChange}
      isDisabled={saving}
      formatOptionLabel={formatOptionLabel}
      components={{ DropdownIndicator, IndicatorSeparator: null }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        container: (base) => ({ ...base, width: '100%', right: '8px' }),
        control: (base, state) => ({
          ...base,
          minHeight: 52,
          height: 56,
          border: 'none',
          // border: state.isFocused ? '1px solid #4CBC18' : '1px solid #DAE4D5',
          borderRadius: 8,
          boxShadow: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          '&:hover': { borderColor: 'transparent' },
        }),
        groupHeading: (base) => ({
          ...base,
          fontSize: 11,
          fontWeight: 700,
          color: '#17270D',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          paddingBottom: 2,
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? '#E7F0E2'
            : state.isFocused
            ? '#f8fef4'
            : '#fff',
          color: '#17270D',
          cursor: 'pointer',
          fontSize: 13,
          padding: '6px 12px',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        input: (base) => ({ ...base, caretColor: 'transparent' }),
        valueContainer: (base) => ({ ...base, padding: '0 10px', height: '100%' }),
        singleValue: (base) => ({ ...base, margin: 0, overflow: 'visible', position:'relative', bottom:'12px' }),
      }}
    />
  );
};

export default StageCellEditor;
